import { Routes } from '@angular/router';
import { UnauthorizedComponent } from '@connect/components/unauthorized/unauthorized.component';
import { WelcomeComponent } from '@connect/components/welcome/welcome.component';

export const routes: Routes = [
	{ path: '', component: WelcomeComponent },
	{ path: 'app', loadChildren: () => import('@connect/secure/secure-routing.module').then(m => m.SecureRoutingModule) },
	{ path: 'public', loadChildren: () => import('@connect/public/public-routing.module').then(m => m.PublicRoutingModule )},
	{ path: 'unauthorized', component: UnauthorizedComponent }
];
